export function isKeyboardEvent(event) {
  return event && event.key !== undefined;
}

export function isMouseEvent(event) {
  return event && event.clientX !== undefined;
}

export function isBarTask(task) {
  return task && task.x1 !== undefined;
}

export function removeHiddenTasks(tasks) {
  const groupedTasks = tasks.filter(
    (t) => t.hideChildren && t.type === "project"
  );

  if (groupedTasks.length > 0) {
    for (let i = 0; i < groupedTasks.length; i++) {
      const groupedTask = groupedTasks[i];
      const children = getChildren(tasks, groupedTask);

      // remove children from task list
      tasks = tasks.filter((t) => children.indexOf(t) === -1);
    }
  }

  return tasks;
}

function getChildren(taskList, task) {
  let tasks = [];

  if (task.type !== "project") {
    // child depends on parent via dependencies []
    tasks = taskList.filter(
      (t) => t.dependencies && t.dependencies.indexOf(task.id) !== -1
    );
  } else {
    // child belongs to project via project field
    tasks = taskList.filter((t) => t.project && t.project === task.id);
  }

  let taskChildren = [];

  tasks.forEach((t) => {
    taskChildren.push(...getChildren(taskList, t));
  });

  // concat direct children and deeper nested children
  tasks = tasks.concat(tasks, taskChildren);

  return tasks;
}

export const sortTasks = (taskA, taskB) => {
  const orderA = taskA.displayOrder || Number.MAX_VALUE;
  const orderB = taskB.displayOrder || Number.MAX_VALUE;

  if (orderA > orderB) return 1;
  if (orderA < orderB) return -1;
  return 0;
};
